//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Logo from '../common/svg/Logo';

export default {
  name: 'Wait',
  components: { Logo },
  data() {
    return {
      open: false,
      message: null,
      messageSize: null,
      buttonText: null,
      buttonType: null,
    };
  },
  created() {
    this.$container.eventBus.on('toggleWait', (e) => {
      this.open = e.open;
      this.message = e.message;
      this.messageSize = e.messageSize || 'in-your-face';
    });
  },
};
